import { AccountArrowRightIcon } from './AccountArrowRightIcon';

/**
 * author: Coffeemate
 * id 6C4EDCE5-0741-4BF4-B16A-112892C6AB98
 * name account-arrow-right
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-right.svg
 * tags
 * - Account / User 
 */
export const UserArrowRightIcon = AccountArrowRightIcon;
export default UserArrowRightIcon